export enum WellKnownNumberTypes {
    email = 4,
}
